// imports
import React from 'react';
import { useSelector } from 'react-redux';
import { Tooltip } from 'react-tooltip';
import { selectConfig } from '../../repositories/store/slices';

// interfaces / types / consts
interface Props {
  traitId: string;
  anchorSelect: string;
  openOnClick?: boolean;
}
const MISSING_TRAIT = { type: 'MISSING_TYPE', value: 'MISSING_VALUE' };

// exports
export default function TraitDetailTooltip(props: Props): JSX.Element {
  const { traitId, anchorSelect, openOnClick } = props;
  const { traits } = useSelector(selectConfig);
  const trait = traits[traitId] || { ...MISSING_TRAIT, description: traitId };
  const { type, value, description } = trait;
  return (
    <Tooltip place="top" variant="light" positionStrategy="fixed" openOnClick={openOnClick} anchorSelect={anchorSelect}>
      <div className="tool-tip">
        <div className="heading">{value}</div>
        <div className="name">{type}</div>
        <div className="description">{description}</div>
      </div>
    </Tooltip>
  );
}

// default props
TraitDetailTooltip.defaultProps = { openOnClick: false };
